import axios from 'axios';
import toast from 'react-hot-toast';
import { v4 as uuidv4 } from 'uuid';
import { addNewScoreBulk } from '../../lib/apiService';
import { foulActions, gameData, made1PT, made2PT, made3PT, miss1PT, miss2PT, miss3PT, resetScoreTemporaryData, scoreLoadingFalse, submitPlayersAndMatchDataWithOutPlaySec, toPT, updateMatchTimeStatus, updatePostingData, updateScoreTemporaryData, updateScoreTemporaryDataOne } from '../reducers/playersReducer';
import { selectEvent } from '../reducers/settingReducer';
import { baseApi } from '../../urlConfig';
const token = window.localStorage.getItem("token");

export const handlePeriodUpdate = (value) => {
  return {
    type: SELECTED_QUARTER,
    payload: value,
  };
};



export const handlePointSelect = (value) => (dispatch) => {
  const actionMap = {
    'MADE_2_PT': made2PT,
    'MADE_3_PT': made3PT,
    'MADE_1_PT': made1PT,
    'MISS_2_PT': miss2PT,
    'MISS_3_PT': miss3PT,
    'MISS_1_PT': miss1PT,
    'TO_PT': toPT,
    'FOUL_ACTIONS': foulActions
  };

  const actionCreator = actionMap[value];

  if (actionCreator) {
    dispatch(actionCreator());
  } else {
    console.warn('Unknown action: ', value);
  }
};


// Extracted score type logic
export const determineScoreType = (point2, point3, point1, pointMiss1, assistPoint, reboundBlockPoint, teamReboundSections, foul, turnoverPoint, foulPT, foulPoint, value, game_data, t_id) => {
  return (
    (point2 && "point2") ||
    (point3 && "point3") ||
    (point1 && "point1") ||
    (pointMiss1 && "pointMiss1") ||
    (assistPoint && "assist") ||
    (reboundBlockPoint && teamReboundSections === "Block" && "block") ||
    (foul && !turnoverPoint && "turnover") ||
    (turnoverPoint && teamReboundSections === "Steal" && "steal") ||
    (foulPT && !foulPoint && "personalFoul") ||
    (foulPoint && value === "TF" && "technicalFoul") ||
    (foulPoint && value === "PF" && "foulDrawn") ||
    (reboundBlockPoint &&
      teamReboundSections &&
      game_data.scoreList[game_data.scoreList.length - 1].t_id === t_id
      ? "offensiveRebound"
      : "defensiveRebound")
  );
};

// Extracted data preparation logic
export const createScoreData = (score_type,
  xPosition,
  yPosition,
  minutes,
  seconds,
  event_id,
  event_group_id,
  playerId,
  t_id,
  quarter,
  starState) => {
  return {
    score_type: score_type,
    loc_x: xPosition || 0,
    loc_y: yPosition || 0,
    score_timer: minutes * 60 + seconds,
    event_id: event_id,
    eg_id: event_group_id,
    r_id: playerId,
    t_id: t_id,
    score_period: quarter,
    star: starState,
  };
};

export const handleScoreDelete = (type, data_id, eg_id, event_id, token, setScoreId, setScoreDeleteModal) => {
  return async (dispatch) => {

    const data = {
      type,
      data_id,
      eg_id,
      event_id,
    };

    const headers = {
      Authorization: token,
      "Content-Type": "multipart/form-data",
    };

    try {

      const response = await axios.post(`${process.env.REACT_APP_API_ROOT}` + "/api/del_score/", data, { headers });

      if (response.status === 201) {
        dispatch(gameData(response.data.score));
        toast.success("Score deleted successfully");
        dispatch(scoreLoadingFalse());
        setScoreDeleteModal(false);
        setScoreId(null);

      } else {
        toast.error("Failed to delete score");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
      toast.error("Error occurred while deleting score");
    }
  };
};


export const handleNavigateStreamingOverlays = (event_code, team_a_name, team_b_name, event_id, event_group_id, navigate) => {
  return (dispatch, getState) => {
    // Access the current state using getState()
    const state = getState();
    const selectEventData = state?.selectEvent || [];  // Access selectEvent from the state, ensure it's an array

    const selectedEventsOptions = localStorage.getItem("selectedEventsOptions");
    const selectedGroupCodes = JSON.parse(localStorage.getItem("selectedGroupCodes")) || [];
    const eventsOptions = selectedEventsOptions ? JSON.parse(selectedEventsOptions) : {};

    // Prepare the matchTitle object
    const matchTitle = {
      eventCode: event_code.slice(2),  // Remove the "EC" prefix
      value: `${event_code} GC${event_group_id} ${team_a_name || 'No Team Name'} vs ${team_b_name || 'No Team Name'}`,
      label: `${event_code} GC${event_group_id} ${team_a_name || 'No Team Name'} vs ${team_b_name || 'No Team Name'}`,
    };

    // Check if the key GC${event_group_id} exists in the current eventsOptions
    const groupKey = `GC${event_group_id}`;
    const existingEvents = eventsOptions[groupKey] || [];

    // Check if the event already exists based on eventCode
    const eventExists = existingEvents.some(event => event.eventCode === event_code.slice(2));

    if (!eventExists) {
      // Add the new event under the specific GC${event_group_id}
      eventsOptions[groupKey] = [...existingEvents, matchTitle];
    }

    // Update selectedGroupCodes if groupKey is not already present
    if (!selectedGroupCodes.includes(groupKey)) {
      selectedGroupCodes.push(groupKey);  // Add groupKey if not already in the list
    }

    // Dispatch actions to update the Redux store

    dispatch(selectEvent([...selectEventData, event_id.toString()]));

    localStorage.setItem("selectedGroupCodes", JSON.stringify(selectedGroupCodes));
    localStorage.setItem("streamingOverlays", "streamingOverlays");
    localStorage.setItem("selectedEventsOptions", JSON.stringify(eventsOptions));
    localStorage.setItem("event_id", event_id);

    // Navigate to the settings page
    navigate("/settings");
  };
};

// Action to handle sending team one playing players' time
export const handleTeamOnePlayingPlayerTimeSend = (matchData, event_team_a_id, event_id, event_group_id, token) => {
  return async (dispatch, getState) => {
    // Create a copy of the team_a_rosters array to avoid mutating the original state


    const teamOneStartingLineUp = matchData?.team_a_rosters
      ?.filter((player) => player.is_Playing === true)
      ?.map((player) => ({
        r_id: player.roster_id,
        t_id: event_team_a_id,
        event_id: event_id,
        eg_id: event_group_id,
        present: true,
        startinglinup: true,
        play_sec: player.play_sec,
      })) || [];


    const formdata = new FormData();
    formdata.append("data", JSON.stringify(teamOneStartingLineUp));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ROOT}` + "/api/playerStatus/",
        formdata,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.data) {

         dispatch(submitPlayersAndMatchDataWithOutPlaySec(JSON.parse(JSON.stringify(response.data.data))));


      }
    } catch (error) {
      console.error("Error submitting team one data:", error);

    }
  };
};

export const handleTeamPlayingPlayerTimeSend = (matchData, event_team_a_id, event_team_b_id, event_id, event_group_id, token) => {
  return async (dispatch, getState) => {
    // Create a copy of the team_a_rosters array to avoid mutating the original state
    const state = getState()
    const openStarterModal = state?.playersReducer?.openStarterModal
    const teamOneStartingLineUp = matchData?.team_a_rosters
      ?.filter((player) => player.is_Playing === true)
      ?.map((player) => ({
        r_id: player.roster_id,
        t_id: event_team_a_id,
        event_id: event_id,
        eg_id: event_group_id,
        present: true,
        startinglinup: true,
        play_sec: player.play_sec,
      })) || [];
       const teamTwoStartingLineUp = matchData?.team_b_rosters
      ?.filter((player) => player.is_Playing === true)
      ?.map((player) => ({
        r_id: player.roster_id,
        t_id: event_team_b_id,
        event_id: event_id,
        eg_id: event_group_id,
        present: true,
        startinglinup: true,
        play_sec: player.play_sec,
      })) || [];

    const margeData = [
      ...teamOneStartingLineUp,
      ...teamTwoStartingLineUp
    ]

    if (margeData.length > 0) {


    const formdata = new FormData();
    formdata.append("data", JSON.stringify(margeData));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ROOT}` + "/api/playerStatus/",
        formdata,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.data) {
        if(!openStarterModal){
         dispatch(submitPlayersAndMatchDataWithOutPlaySec(JSON.parse(JSON.stringify(response.data.data))));
        }

      }

    } catch (error) {
      console.error("Error submitting team one data:", error);

      }
       }
  };
};
// Action to handle sending team one playing players' time
export const handleTeamOnePlayingPlayerTimeSend2 = (matchData, event_team_b_id, event_id, event_group_id, token) => {
  return async (dispatch, getState) => {
    // Create a copy of the team_a_rosters array to avoid mutating the original state


    const teamTwoStartingLineUp = matchData?.team_b_rosters
      ?.filter((player) => player.is_Playing === true)
      ?.map((player) => ({
        r_id: player.roster_id,
        t_id: event_team_b_id,
        event_id: event_id,
        eg_id: event_group_id,
        present: true,
        startinglinup: true,
        play_sec: player.play_sec,
      })) || [];

    const formdata = new FormData();
    formdata.append("data", JSON.stringify(teamTwoStartingLineUp));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ROOT}` + "/api/playerStatus/",
        formdata,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.data) {

          dispatch(submitPlayersAndMatchDataWithOutPlaySec(JSON.parse(JSON.stringify(response.data.data))));

      }
    } catch (error) {
      console.error("Error submitting team two data:", error);
      // toast.error("Failed to submit team two player data");  // Optional: Show a toast notification
    }
  };
};


// Action to handle sending team two playing players' time
export const handleTeamTwoPlayingPlayerTimeSend = (matchData, event_team_b_id, event_id, event_group_id, token) => {
  return async (dispatch) => {
    // Create a copy of the team_b_rosters array to avoid mutating the original state
    const teamTwoStartingLineUp = matchData?.team_b_rosters
      ?.filter((player) => player.is_Playing === true)
      ?.map((player) => ({
        r_id: player.roster_id,
        t_id: event_team_b_id,
        event_id: event_id,
        eg_id: event_group_id,
        present: true,
        startinglinup: true,
        play_sec: player.play_sec,
      })) || [];

    const formdata = new FormData();
    formdata.append("data", JSON.stringify(teamTwoStartingLineUp));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ROOT}` + "/api/playerStatus/",
        formdata,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.data) {

        dispatch(submitPlayersAndMatchDataWithOutPlaySec(JSON.parse(JSON.stringify(response.data.data))));
      }
    } catch (error) {
      console.error("Error submitting team two data:", error);
      // toast.error("Failed to submit team two player data");  // Optional: Show a toast notification
    }
  };
};



export const handleScoreTemporaryData = (data) => {
  return (dispatch) => {
    const {
      playerId, t_id, value, fieldLocation, minutes, seconds,
      event_id, event_group_id, quarter, starState, scoreTemporaryData,
      point2, point3, point1, pointMiss1, pointMiss2, pointMiss3,
      assistPoint, reboundBlockPoint, teamReboundSections, foul,
      turnoverPoint, foulPT, foulPoint, user_id, sl_no, teamTurnoverSections
    } = data;

    const { x: xPosition = 0, y: yPosition = 0 } = fieldLocation || {};
    const scoreTimer = minutes * 60 + seconds;

  const determineScoreType = () => {
  const conditions = [
    { condition: () => point2, result: 'point2' },
    { condition: () => point3, result: 'point3' },
    { condition: () => point1, result: 'point1' },
    { condition: () => pointMiss1, result: 'pointMiss1' },
    { condition: () => pointMiss2, result: 'pointMiss2' },
    { condition: () => pointMiss3, result: 'pointMiss3' },
    { condition: () => assistPoint, result: 'assist' },
    { condition: () => reboundBlockPoint && teamReboundSections === 'Block', result: 'block' },
    { condition: () => foul && !turnoverPoint, result: 'turnover' },
    { condition: () => turnoverPoint && teamTurnoverSections === 'Steal', result: 'steal' },
    { condition: () => foulPT && !foulPoint, result: 'personalFoul' },
    { condition: () => foulPoint && value === 'TF', result: 'technicalFoul' },
    { condition: () => foulPoint && value === 'PF', result: 'foulDrawn' },
    {
      condition: () => reboundBlockPoint && teamReboundSections,
      result: () => scoreTemporaryData[0]?.t_id === t_id ? 'offensiveRebound' : 'defensiveRebound'
    },
  ];

  for (const { condition, result } of conditions) {
    if (condition()) {
      return typeof result === 'function' ? result() : result;
    }
  }

  return 'defensiveRebound';
};

    const score_type = determineScoreType();

    const formattedData = {
      score_type: score_type,
      loc_x: xPosition,
      loc_y: yPosition,
      score_timer: scoreTimer,
      event_id: event_id,
      eg_id: event_group_id,
      r_id: playerId,
      t_id: t_id,
      sl_no: sl_no,
      score_period: quarter,
      star: starState,
      scorer_id: user_id,
    };

    if (value === "TF") {
      dispatch(updateScoreTemporaryDataOne(formattedData));
    } else {
      dispatch(updateScoreTemporaryData(formattedData));
    }

    const uniqueId = uuidv4();
    dispatch(updatePostingData({
      ...formattedData,
      status: 'loading',
      scorer_id: user_id,
      unique_id: uniqueId
    }));
  };
};

export const handleAddNewScoreReBulk = (unique_id, filteredPostingData, setStarState, setTeamFoulSections, setPostingError) => {
  return async (dispatch) => {
    const postData = filteredPostingData.filter((data) => data.unique_id === unique_id);
    const formdata = new FormData();
    formdata.append("data", JSON.stringify([...postData]));
    const token = window.localStorage.getItem("token");

    try {
      dispatch(resetScoreTemporaryData());
      const response = await addNewScoreBulk(formdata, token); // Call the API directly here
      if (response) {
        dispatch(gameData(response.data.score));
        setStarState(false);
        setTeamFoulSections("PF");
        setPostingError(false);
      }
    } catch (error) {
      setPostingError(true);
    }
  };
};


export const handleAddNewScoreBulk = (scoreTemporaryData, setStarState, setTeamFoulSections, setPostingError) => {
  return async (dispatch) => {
    const formData = new FormData();
    formData.append("data", JSON.stringify([...scoreTemporaryData]));
    const token = window.localStorage.getItem("token");
    dispatch(resetScoreTemporaryData());

    try {
      // Use the helper function to make the POST request
      const response = await addNewScoreBulk(formData, token);

      if (response && response.data) {
        dispatch(gameData(response.data.score));
        setStarState(false);
        setTeamFoulSections('PF');
        setPostingError(false);

      }
    } catch (error) {
      setPostingError(true);
    }
  };
};


export const sendTimerData = (
  { shotClockValue,
    currentIsRunning,
    minutes,
    seconds,
    event_id,
    event_group_id,
    quarter,
    event_team_a_id,
    event_team_b_id
  }) => {
  return async (dispatch,getState) => {  // Ensure the function returns another function
    const state = getState();
    const possessionArrowTeamOne = state?.playersReducer?.possessionArrowTeamOne;
    const possessionArrowTeamTwo = state?.playersReducer?.possessionArrowTeamTwo;
  
    try {
      const formData = new FormData();
      formData.append("score_timer", minutes * 60 + seconds);
      formData.append("event_id", event_id);
      formData.append("eg_id", event_group_id);
      formData.append("score_period", quarter);
      formData.append("timerStatus", currentIsRunning ? "p" : "r");
      formData.append("shotclock", shotClockValue);
      formData.append("possession", possessionArrowTeamOne ? event_team_a_id : event_team_b_id);

      const token = window.localStorage.getItem("token");
      const response = await axios.post(`${baseApi}/set_timer/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `${token}`,
        },
      });
      const game_status = response.data.game_status;
      dispatch(updateMatchTimeStatus({
        ...game_status,
      }));
    } catch (error) {
      console.error("Error:", error);
    }
  };
}